import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ChildrenOutletContexts, RouterOutlet } from '@angular/router';
import { SpinnerComponent } from "./shared/components/ui-components/spinner/spinner.component";
import { RoutingService } from './core/services/routing.service';
import { AuthService } from './core/services/auth.service';
import { ApiService } from './core/services/api.service';
import { AppState } from './core/models/app.model';
import { SignalStore } from './shared/functions/store.functions';
import { CommonModule } from '@angular/common';
import { KeycloakService } from 'keycloak-angular';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SpinnerComponent,CommonModule],

  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'Modernize Angular Admin Template';

  constructor(
    @Inject('app-store') private readonly appStore: SignalStore<AppState>,

    public apiService: ApiService,
    private readonly authService: AuthService,
    private contexts: ChildrenOutletContexts,
    private routingService: RoutingService,
    private keycloakService: KeycloakService
  
  ) {

  }
  isAuthenticated() {

    return this.authService.isAuthenticated();
  }
}
